
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/provider-form",
      function () {
        return require("private-next-pages/provider-form.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/provider-form"])
      });
    }
  